import './PhilModalPlaceholder.css';

import { PhilModalVariant } from '@farmasiet/iframe-messages';
import classNames from 'classnames';
import React from 'react';

interface PhilModalPlaceholderProps {
    variant: PhilModalVariant;
    isMobile: boolean;
}

export const PhilModalPlaceholder = (props: PhilModalPlaceholderProps) => {
    const isSideVariant = props.variant !== PhilModalVariant.Center;

    return (
        <div
            className={classNames(
                'PhilModalPlaceholder',
                isSideVariant && 'PhilModalPlaceholder--SideVariant',
                !props.isMobile && 'PhilModalPlaceholder--IsDesktop'
            )}
        >
            <div className="PhilModalPlaceholder__TitleWrapper">
                <div className="Placeholder__Rect Placeholder__Rect--HeightM Placeholder__Rect--WidthXXXL" />
            </div>
            <div className="PhilModalPlaceholder__ContentWrapper PhilModalPlaceholder__ContentWrapper--Desktop">
                <div className="PhilModalPlaceholder__ContentSection PhilModalPlaceholder__ContentSection--WithBiggerSpacing">
                    <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                    <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                    <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                    <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                    <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                </div>
                <div className="PhilModalPlaceholder__ContentSection">
                    <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                    <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                </div>
            </div>
            <div className="PhilModalPlaceholder__ContentWrapper PhilModalPlaceholder__ContentWrapper--Mobile">
                {isSideVariant ? (
                    <div className="PhilModalPlaceholder__ContentSection">
                        <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                        <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                        <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                    </div>
                ) : (
                    <div className="Placeholder__Rect Placeholder__Rect--HeightS" />
                )}
            </div>
            {!isSideVariant && (
                <div className="PhilModalPlaceholder__ButtonsWrapper">
                    <div className="Placeholder__Rect Placeholder__Rect--HeightXL Placeholder__Rect--WidthXXL" />
                    <div className="Placeholder__Rect Placeholder__Rect--HeightXL Placeholder__Rect--WidthXXL" />
                </div>
            )}
        </div>
    );
};
